import LogoImage from "common/components/logo-image";
import MeshBg from "common/images/bg.png";

const BgLayout = ({ 
  children, 
  admin = false, 
  partner = false,
  aside,
  bgColor,
  logo,
}) => {
  return (
    <main className="min-h-screen w-full flex flex-col items-center justify-center mobile:justify-start relative py-12 mobile:py-8" style={{ backgroundColor: bgColor }}>
      {/* mesh bg */}
      {!bgColor && (
        <img
          src={MeshBg}
          alt="aside mesh bg"
          className="absolute top-0 left-0 w-full h-full z-0 object-cover"
        />
      )}

      {/* wrapper */}

      {/* container */}
      <section className="w-fit max-w-4xl flex flex-col justify-center items-center gap-12 relative">
        {/* desktop logo */}
        <div className="flex flex-col gap-2">
          {logo ? (
            <img
              src={logo}
              alt="Property Logo"
              className="w-full h-auto max-w-[180px] max-h-[60px]"
            />
          ) : (
            <div className={`flex flex-col w-fit items-end gap-1`}>
              <LogoImage className="ml-4 mobile:ml-3" size="s" />
              {admin && (
                <span className="text-sm font-medium text-gray-500">
                  Admin Portal
                </span>
              )}
              {partner && (
                <span className="text-sm font-medium text-gray-500">
                  Partner Portal
                </span>
              )}
            </div>
          )}
        </div>

        <div
          className={`grid ${
            aside ? "mobile:grid-cols-1 grid-cols-[2fr_1fr]" : "grid-cols-1"
          } w-full mobile:max-w-md max-w-4xl gap-8 mobile:gap-4 mobile:px-2`}
        >
          {/* white bg */}
          <div className="w-fit h-full rounded-md border border-gray-200 bg-white p-12 mobile:px-8 flex flex-col items-center justify-center gap-12 max-w-xl">
            {/* mobile logo */}
            {/* <div className="mobile:flex flex-col gap-2 hidden">
              <LogoImage dark={true} />
              {admin && (
                <span className="uppercase font-semibold tracking-wider">
                  Admin Portal
                </span>
              )}
            </div> */}

            {/* children elements */}
            {children}
          </div>

          {/* aside */}
          {aside && <div className="">{aside}</div>}
        </div>
      </section>
    </main>
  );
};

export default BgLayout;
